import React, { useContext } from "react";
import "./accountReviews.css";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";
import dayjs from "dayjs";

const AccountReviews = () => {
	const { userData, language } = useContext(CombinedContext);


	// ✅ Placeholder reviews array – replace with real API data
	const myReviews = [
		// {
		// 	shopName: "Barbería Santo",
		// 	rating: 5,
		// 	comment: "Super professional, highly recommend!",
		// 	date: "2024-10-01",
		// }
	];

	return (
		<div className="sf-reviews-page">
			<h2 className="sf-rev-title">{translations[language]?.account?.reviews.title}</h2>

			{myReviews.length === 0 ? (
				<div className="sf-rev-empty">
					<p>{translations[language]?.account?.reviews.empty}</p>
				</div>
			) : (
				<div className="sf-rev-list">
					{myReviews.map((review, index) => (
						<div key={index} className="sf-rev-card">
							<div className="sf-rev-header">
								<div className="sf-rev-shop">{review.shopName}</div>
								<div className="sf-rev-date">
									{dayjs(review.date).format("MMM D, YYYY")}
								</div>
							</div>

							<div className="sf-rev-rating">
								{"⭐".repeat(review.rating)}{" "}
								<span className="sf-rev-rating-num">({review.rating})</span>
							</div>

							<p className="sf-rev-comment">{review.comment}</p>
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default AccountReviews;
